function blockDevTools() {
  const redirectTo = "https://dev.fsdeafs.com.br";

  const devToolsDetector = setInterval(() => {
    const threshold = 160;
    const widthThreshold = window.outerWidth - window.innerWidth > threshold;
    const heightThreshold = window.outerHeight - window.innerHeight > threshold;

    if (widthThreshold || heightThreshold) {
      clearInterval(devToolsDetector);
      window.location.href = redirectTo;
    }
  }, 1000);

  const blockKeyCombination = (event) => {
    const blockedKeys = [
      { key: "I", ctrlKey: true, shiftKey: true },
      { key: "J", ctrlKey: true, shiftKey: true },
      { key: "C", ctrlKey: true, shiftKey: true },
      { key: "S", ctrlKey: true, shiftKey: true },
      { key: "U", ctrlKey: true },
      { key: "F11" },
      { key: "F12" },
    ];

    blockedKeys.forEach((blockedKey) => {
      const keyMatches = event.key.toUpperCase() === blockedKey.key;
      const ctrlMatches = event.ctrlKey === !!blockedKey.ctrlKey;
      const shiftMatches = event.shiftKey === !!blockedKey.shiftKey;

      if (keyMatches && ctrlMatches && shiftMatches) {
        event.preventDefault();
        window.location.href = redirectTo;
      }
    });
  };

  const blockContextMenu = (event) => {
    event.preventDefault();
    window.location.href = redirectTo;
  };

  const blockViewSource = () => {
    if (window.location.href.startsWith("view-source:")) {
      window.location.href = redirectTo;
    }
  };

  const blockConsoleAccess = () => {
    Object.defineProperty(window, "console", {
      get: () => ({
        log: () => {},
        warn: () => {},
        error: () => {},
        info: () => {},
      }),
    });
  };

  const detectDevTools = () => {
    const devToolsCheck = setInterval(() => {
      const widthThreshold = window.outerWidth - window.innerWidth > 160;
      const heightThreshold = window.outerHeight - window.innerHeight > 160;

      if (widthThreshold || heightThreshold) {
        clearInterval(devToolsCheck);
        window.location.href = redirectTo;
      }
    }, 1000);
  };

  window.addEventListener("keydown", blockKeyCombination);
  window.addEventListener("contextmenu", blockContextMenu);
  blockViewSource();
  blockConsoleAccess();
  detectDevTools();
}

blockDevTools();
